import React from 'react';

type SectionVariant = 'elevated' | 'flat' | 'bare';

interface SectionContainerProps extends React.HTMLAttributes<HTMLElement> {
  children: React.ReactNode;
  innerClassName?: string;
  variant?: SectionVariant;
  testId?: string;
  'aria-label'?: string;
  'aria-labelledby'?: string;
}

export default function SectionContainer({
  children,
  className = '',
  innerClassName = '',
  variant = 'elevated',
  testId,
  'aria-label': ariaLabel,
  'aria-labelledby': ariaLabelledby,
  ...rest
}: SectionContainerProps) {
  // Unified vertical rhythm: Mobile 16px, Tablet 20px, Desktop 24px
  // Using Tailwind responsive classes for consistent spacing
  const verticalSpacing = 'py-4 md:py-5 lg:py-6'; // 16px / 20px / 24px

  if (variant === 'bare') {
    return (
      <section 
        className={`w-full ${verticalSpacing} ${className}`}
        data-testid={testId}
        aria-label={ariaLabel}
        aria-labelledby={ariaLabelledby}
        {...rest}
      >
        <div className={innerClassName}>{children}</div>
      </section>
    );
  }

  const variantClass =
    variant === 'flat'
      ? 'section-shell section-shell--flat'
      : 'section-shell section-shell--elevated';

  return (
    <section 
      className={`w-full ${verticalSpacing} ${className}`}
      data-testid={testId}
      aria-label={ariaLabel}
      aria-labelledby={ariaLabelledby}
      {...rest}
    >
      <div className={`${variantClass} ${innerClassName}`}>
        {children}
      </div>
    </section>
  );
} 